import React from "react";
import { Gift, Sparkles, Crown } from "lucide-react";
import { originalBonuses, extraBonuses } from "../../data/mock";

const BonusCard = ({ b, highlight }) => (
  <div
    className={`relative bg-white rounded-2xl p-4 md:p-6 border-2 ${highlight ? "border-amber-300" : "border-pink-100"} shadow-sm card-hover overflow-hidden`}
  >
    <div className="absolute top-0 right-0 w-24 h-24 -mr-8 -mt-8 rounded-full bg-pink-100/50" />
    <div className="relative flex items-start gap-3 md:gap-4">
      <div className={`shrink-0 w-11 h-11 md:w-14 md:h-14 rounded-xl grid place-content-center text-white font-black shadow-md ${highlight ? "bg-gradient-to-br from-amber-400 to-amber-600" : "bg-gradient-to-br from-pink-500 to-rose-600"}`}>
        <Gift className="w-5 h-5 md:w-6 md:h-6" />
      </div>
      <div className="flex-1 min-w-0">
        <div className="text-[10px] md:text-[11px] tracking-widest font-bold text-pink-500 uppercase">Bônus #{b.n}</div>
        <h3 className="mt-0.5 font-bold text-pink-800 text-[15px] md:text-lg leading-snug">{b.title}</h3>
        <p className="mt-1.5 md:mt-2 text-[13px] md:text-sm text-pink-900/70 leading-relaxed">{b.desc}</p>
        <div className="mt-2.5 md:mt-3 flex flex-wrap items-center gap-2">
          <span className="text-pink-900/50 line-through text-xs md:text-sm">Valor: {b.value}</span>
          <span className="inline-flex items-center gap-1 bg-green-100 text-green-700 text-[10px] md:text-xs font-bold px-2.5 py-1 rounded-full uppercase tracking-wider">
            <Sparkles className="w-3 h-3" /> Grátis hoje
          </span>
        </div>
      </div>
    </div>
  </div>
);

const Bonuses = () => {
  return (
    <section className="section-pad bg-gradient-to-b from-white to-pink-50/60">
      <div className="max-w-6xl mx-auto px-4">
        <div className="text-center max-w-2xl mx-auto">
          <span className="inline-flex items-center gap-2 text-[11px] md:text-xs font-bold tracking-widest text-pink-600 uppercase">
            <Gift className="w-4 h-4" /> Bônus Exclusivos
          </span>
          <h2 className="mt-2 font-serif-display font-black text-2xl md:text-5xl text-pink-700 leading-tight">
            Você também vai receber...
          </h2>
          <p className="mt-3 md:mt-4 text-pink-900/70 text-sm md:text-base">
            Ao garantir sua vaga hoje, você leva <strong className="text-pink-700">TODOS os bônus abaixo 100% GRÁTIS</strong>.
          </p>
        </div>

        {/* Original Bonuses */}
        <div className="mt-6 md:mt-10 grid sm:grid-cols-2 lg:grid-cols-3 gap-3 md:gap-5">
          {originalBonuses.map((b, i) => (
            <BonusCard key={`orig-${i}`} b={b} />
          ))}
        </div>

        {/* Extra Bonuses */}
        <div className="mt-10 md:mt-14">
          <div className="text-center max-w-2xl mx-auto">
            <div className="inline-flex items-center gap-2 bg-pink-100 text-pink-700 rounded-full px-3 md:px-4 py-1.5 text-[11px] md:text-sm font-bold uppercase tracking-wider">
              <Sparkles className="w-3.5 h-3.5 md:w-4 md:h-4" /> Novos bônus liberados
            </div>
            <h3 className="mt-3 font-serif-display font-black text-xl md:text-4xl text-pink-700 leading-tight">
              +13 bônus adicionais para acelerar suas vendas
            </h3>
          </div>

          <div className="mt-5 md:mt-8 grid sm:grid-cols-2 lg:grid-cols-3 gap-3 md:gap-5">
            {extraBonuses.map((b, i) => (
              <BonusCard key={`extra-${i}`} b={b} />
            ))}
          </div>
        </div>

        {/* Special Bonus */}
        <div className="mt-10 md:mt-14">
          <div className="relative overflow-hidden rounded-3xl border-2 border-amber-300 bg-gradient-to-br from-amber-50 via-rose-50 to-pink-50 p-5 md:p-10 shadow-xl">
            <div className="absolute -top-16 -right-16 w-64 h-64 rounded-full bg-amber-200/40 blur-3xl" />
            <div className="relative">
              <div className="flex items-center gap-2 text-amber-700 font-bold uppercase text-[10px] md:text-xs tracking-widest">
                <Crown className="w-4 h-4 md:w-5 md:h-5" /> Bônus Especial — Exclusivo
              </div>
              <h3 className="mt-2 font-serif-display font-black text-xl md:text-4xl text-pink-800 leading-tight">
                Biblioteca Premium com +300 Artes Exclusivas
              </h3>
              <p className="mt-3 text-pink-900/80 max-w-3xl text-sm md:text-base">
                Uma coleção inédita com mais de <strong>300 artes profissionais</strong>, desenvolvidas para complementar seu negócio e economizar horas de criação.
              </p>

              <div className="mt-5 md:mt-6 grid sm:grid-cols-2 gap-3">
                {[
                  ["100 Tags Premium", "Agradecimento, Feito com Amor, Datas Comemorativas, Personalizadas e Luxo"],
                  ["50 Sacolas Personalizadas", "Prontas para editar no Canva e imprimir"],
                  ["50 Caixas Exclusivas", "Modelos para presentes, kits e embalagens sofisticadas"],
                  ["50 Adesivos Profissionais", "Perfeitos para embalagens, lacres e personalização"],
                  ["50 Cartões de Agradecimento", "Modelos modernos para fidelizar clientes"],
                  ["Uso Comercial Liberado", "Alta resolução e prontos para impressão"],
                ].map(([t, d], i) => (
                  <div key={i} className="bg-white/80 backdrop-blur rounded-xl p-3 md:p-4 border border-amber-200">
                    <div className="font-bold text-pink-800 text-[13px] md:text-sm flex items-center gap-2">
                      <span className="w-1.5 h-1.5 rounded-full bg-amber-500" />
                      {t}
                    </div>
                    <div className="text-[11px] md:text-xs text-pink-900/70 mt-1 pl-3.5">{d}</div>
                  </div>
                ))}
              </div>

              <div className="mt-5 md:mt-6 flex flex-wrap items-center gap-2 md:gap-3">
                <span className="text-pink-900/50 line-through text-sm md:text-lg">De R$57,00</span>
                <span className="inline-flex items-center gap-1 bg-green-500 text-white text-[11px] md:text-sm font-bold px-3 py-1.5 rounded-full uppercase tracking-wider shadow">
                  <Sparkles className="w-3.5 h-3.5 md:w-4 md:h-4" /> GRÁTIS hoje
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Bonuses;
